import { cn } from '@/utils/styles';
import { Link } from '@design-system/Link';
import { Button } from '@design-system/Button';
import { NavBar } from '@design-system/NavBar';
import { Avatar } from '@design-system/Avatar';
import { SETTINGS_PATH } from '@/constants/paths';
import { SettingsIcon } from '@/components/icons/SettingsIcon';
import { useUserDetails } from '@/hooks/useUserDetails';

export interface AccountManagementPageProfileSectionProps
  extends React.ComponentProps<'div'> {
  className?: string;
}

export const AccountManagementPageProfileSection = ({
  className,
}: AccountManagementPageProfileSectionProps) => {
  const { firstName } = useUserDetails();

  return (
    <div className={cn('flex flex-col', className)}>
      <NavBar hideReturnButton>
        <Button asChild variant="ghost" size="icon">
          <Link to={SETTINGS_PATH} className="[&_svg]:!size-6">
            <SettingsIcon aria-label="My profile settings" />
          </Link>
        </Button>
      </NavBar>

     <Avatar size="large" username={firstName} />
    </div>
  );
};
